/* Dimora di Tiro motion.
   Two jobs:
   1. Move the full screen overlays to the end of <body> so no ancestor
      can ever bound their position:fixed geometry or trap them in its
      stacking order. This covers the menu drawer, its backdrop, the search
      panel, and the product page detail drawer with its backdrop. The
      product ones sit inside #MainContent, whose fade-in animation keeps it
      layered below the sticky header, which hid the drawer title and close
      button behind the header.
   2. Add .dm-motion to <html>, then .dm-in to blocks as they enter view.
   Both are additive: classes and DOM position only, never content. */
(function () {
  var docEl = document.documentElement;

  // The product selectors name the element type on purpose: elements inside
  // the drawer (its title) carry ids with the same prefix and must stay put.
  var PORTALED = [
    '.dm-drawer', '.dm-overlay', '.dm-search',
    'div[id^="dm-pdov-"]', 'aside[id^="dm-pddr-"]'
  ];

  function portal() {
    PORTALED.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (el.parentElement === document.body) return;
        // The theme editor re-renders sections. Drop the copy that was moved
        // here on an earlier render so ids never end up duplicated.
        if (el.id) {
          Array.prototype.slice.call(document.body.children).forEach(function (old) {
            if (old !== el && old.id === el.id) old.remove();
          });
        }
        document.body.appendChild(el);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', portal);
  } else {
    portal();
  }
  document.addEventListener('shopify:section:load', portal);

  // No IntersectionObserver means no .dm-motion class, so nothing is ever
  // hidden and the site renders exactly as it does today.
  if (!('IntersectionObserver' in window)) return;

  docEl.classList.add('dm-motion');

  var SELECTORS = [
    '.dm-hero__inner',
    '.dm-ic__head', '.dm-ic__card',
    '.dm-ed__head', '.dm-ed__statement', '.dm-ed__nav-row', '.dm-ed__card',
    '.dm-lay__title', '.dm-lay__sub', '.dm-lay__media-row', '.dm-lay__text-row',
    '.dm-sp__col',
    '.dm-q__text', '.dm-q__by', '.dm-q__mark',
    '.dm-mt__head', '.dm-mt__tile',
    '.dm-sb__media', '.dm-sb__panel',
    '.dm-is__text', '.dm-is__media',
    '.dm-pr__intro', '.dm-pr__row',
    '.dm-cg__intro', '.dm-cg__meta', '.dm-cg__card',
    '.dm-pd__title', '.dm-pd__notes', '.dm-pd__opts', '.dm-pd__panel',
    '.dm-pd__promo', '.dm-pd__intensity', '.dm-pd__desc', '.dm-pd__rows',
    '.dm-st__head', '.dm-st__left', '.dm-st__media',
    '.dm-rt__title', '.dm-rt__block',
    '.dm-ct__title', '.dm-ct__intro', '.dm-ct__detail', '.dm-ct__form',
    '.dm-rv__head', '.dm-rv__card',
    '.dm-po__body',
    '.dm-ft__brand', '.dm-ft__cols'
  ].join(',');

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('dm-in');
      observer.unobserve(entry.target);
    });
  }, {
    root: null,
    rootMargin: '0px 0px -8% 0px',
    threshold: 0.08
  });

  function prepare(root) {
    var scope = root || document;
    var counts = {};

    scope.querySelectorAll(SELECTORS).forEach(function (el) {
      if (el.classList.contains('dm-reveal')) return;
      if (el.closest('.dm-drawer, .dm-search, .dm-overlay')) return;

      el.classList.add('dm-reveal');

      var parent = el.parentElement;
      if (parent) {
        var key = parent.getAttribute('data-dm-group');
        if (!key) {
          key = 'g' + Math.random().toString(36).slice(2, 8);
          parent.setAttribute('data-dm-group', key);
        }
        counts[key] = (counts[key] || 0) + 1;
        var n = counts[key];
        if (n > 1 && n <= 6) el.setAttribute('data-dm-delay', String(n - 1));
      }

      observer.observe(el);
    });
  }

  function revealVisible(root) {
    (root || document).querySelectorAll('.dm-reveal').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) {
        el.classList.add('dm-in');
        observer.unobserve(el);
      }
    });
  }

  function init() {
    prepare(document);
    revealVisible(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    prepare(e.target);
    e.target.querySelectorAll('.dm-reveal').forEach(function (el) {
      el.classList.add('dm-in');
    });
  });
})();
